export default __webpack_public_path__ + "static/media/image-29.657aa93e.png";